import axios from 'axios';
import Common from './Common';
export default {
    create(data){
        return axios.post(Common.api+'aff-log',data);
    },
    createResgistration2(data){
        return axios.post(Common.api + 'aff-registration', data);
    },
}